import { useBlackFriday } from "../context/blackFridayContext"
import Price from "../appData/price"

export interface PricingData {
  totalPrice: string
  discountedPrice: string
  yearlyPerMonthPrice: string
  monthlyPrice: string
  savePercent: number
}

/**
 * Custom hook to calculate and format pricing data for paywalls.
 * Handles both regular pricing and premium-to-ultimate pricing.
 */
export const usePricingData = (): PricingData => {
  const { state } = useBlackFriday()

  // Use ultimatePricing for premium-to-ultimate case, otherwise use currentPricing
  const pricing = state.isPremiumUser
    ? state.ultimatePricing
    : state.currentPricing

  console.log(JSON.stringify(pricing))

  let totalPrice, discountedPrice, yearlyPerMonthPrice, monthlyPrice

  if (state.isPremiumUser) {
    // Premium to Ultimate pricing
    totalPrice = pricing.yearlyPriceFull.formatted
    discountedPrice = pricing.yearlyPriceDiscounted.formatted
    yearlyPerMonthPrice = pricing.discountedMonthlyPrice.formatted
    monthlyPrice = new Price(
      pricing.baseProduct.price,
      pricing.baseProduct.priceLocale,
    ).formatted
  } else {
    // Regular pricing
    monthlyPrice = new Price(
      pricing.baseProduct.price,
      pricing.baseProduct.priceLocale,
    ).formatted
    totalPrice = pricing.yearlyPriceFull.formatted
    discountedPrice = pricing.yearlyPriceDiscounted.formatted
    yearlyPerMonthPrice = new Price(
      pricing.yearlyPriceDiscounted.value / 12,
      pricing.baseProduct.priceLocale,
    ).formatted
  }

  const savePercent = Math.round(
    ((pricing.yearlyPriceFull.value - pricing.yearlyPriceDiscounted.value) /
      pricing.yearlyPriceFull.value) *
      100,
  )

  return {
    totalPrice,
    discountedPrice,
    yearlyPerMonthPrice,
    monthlyPrice,
    savePercent,
  }
}
